import * as React from 'react';
import { css } from 'aphrodite';

import styles from './SVGStyles';

export default class FoundSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g id="illustration_found" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon id="Fill-10" fill="#FFFFFF" points="37 80 77 80 77 57 37 57" />
          <path
            d="M50,40 L50,32 L57,32 L57,40 L62.0032959,40 L75,57 L37,57 L24,40 L50,40 Z M22.845,29.626 L21.964,27.246 C21.664,26.545 20.948,25.385 19.99,24.554 L18.366,23.313 L19.954,22.289 C21.023,21.412 21.429,20.659 21.964,19.384 L22.845,17 L23.585,19.384 C24.02,20.465 24.801,21.521 25.71,22.248 L27.324,23.313 L25.917,24.276 C24.978,25.092 24.31,25.928 23.814,27.067 L22.845,29.626 Z M80,74.9994 L80,66.9994 L94,66.9994 L94,74.9994 L80,74.9994 Z"
            id="Combined-Shape"
            className={css(styles.action)}
          />
          <path
            d="M75,65 L73.143041,65 L72,62 L96,62 L96,65 L78,65 L78,81 L75,81 L75,65 Z M11,57 L24.002,40 L37.004,57 L37.004,80 L11,80 L11,57 Z"
            id="Combined-Shape"
            className={css(styles.grey)}
          />
          <path
            d="M20.026,69.7962646 C20.026,67.8262646 22.011,66 24,66 C25.99,66 28,67.8262646 28,69.7962646 L28,80 L20,80 L20.026,69.7962646 Z M55,72 L55,65 L59,65 L59,72 L55,72 Z M66,72 L66,65 L70,65 L70,72 L66,72 Z M44,72 L44,65 L48,65 L48,72 L44,72 Z M11.081,41.931 L9.76,38.363 C9.31,37.312 8.236,35.573 6.801,34.326 L4.366,32.466 L6.746,30.931 C8.349,29.617 8.958,28.487 9.76,26.575 L11.081,23 L12.191,26.575 C12.842,28.195 14.014,29.779 15.377,30.869 L17.795,32.466 L15.686,33.91 C14.28,35.132 13.278,36.386 12.535,38.094 L11.081,41.931 Z"
            id="Combined-Shape"
            className={css(styles.actionAccent)}
          />
        </g>
      </svg>
    );
  }
}
